module.exports = __webpack_public_path__ + "static/img/136.6edf9c10.png";